import { CheckSvg } from 'components/top/extend/svg/check'

export function SPTopExtendMenu04() {
  return (
    <div
      id='sp-menu-04'
      className='max-w-[360px] w-full mx-auto relative mt-[46px]'
    >
      <div className='z-10 absolute inset-0 h-fit'>
        <img
          src='/images/top-sp-extend/menu-02/roof.webp'
          alt='roof'
          className='w-full aspect-[360/104] object-contain'
        />
        <div className='flex flex-col items-center w-full absolute inset-0 pt-[17px]'>
          <div className='w-[32px] h-[32px] bg-accent-green rounded-full absolute top-0 grid place-content-center transform -translate-y-1/2'>
            <p className='text-[20px] leading-[20px] font-semibold text-white'>
              4
            </p>
          </div>
          <p className='text-[16px] leading-[2] tracking-[0.48px]'>
            空いた時間が
          </p>
          <h2 className='text-[20px] leading-[1.8] tracking-[2px] font-semibold'>
            楽しみに
          </h2>
        </div>
      </div>

      <div className='w-full px-[10px] flex flex-col'>
        <div className='bg-white pt-[137px] px-8 flex flex-col'>
          <p className='text-[16px] font-semibold leading-[1.8] tracking-[1.6px] border-b-[3px] border-accent-green w-fit'>
            できること
          </p>
          <h3 className='text-[22px] font-semibold leading-[1.64] tracking-[2.2px] mt-4'>
            健康に役立つ記事・動画やイベントが満載！
          </h3>
          <div className='mt-2 flex gap-2'>
            <CheckSvg className='w-4 h-4 transform !translate-y-0 shrink-0 mt-2.5' />
            <p className='text-[16px] leading-[2] tracking-[0.48px]'>
              健康などのマメ知識が満載
            </p>
          </div>
          <div className='mt-1 flex gap-2'>
            <CheckSvg className='w-4 h-4 transform !translate-y-0 shrink-0 mt-2.5' />
            <p className='text-[16px] leading-[2] tracking-[0.48px]'>
              食や落語などジャンルも豊富
            </p>
          </div>
          <div className='mt-1 flex gap-2'>
            <CheckSvg className='w-4 h-4 transform !translate-y-0 shrink-0 mt-2.5' />
            <p className='text-[16px] leading-[2] tracking-[0.48px]'>
              その他、あなたのウエルネスな行動を応援するイベントが盛りだくさん！
            </p>
          </div>

          <p className='mt-1 text-[11px] leading-[2]'>
            ※画像は終了したイベントで、一部オトク継続便またはお試し中の方限定イベントも含みます。
            <br />
            ※イベントは不定期で登場します。最新のイベント内容はアプリでご確認ください。
          </p>
        </div>

        <div className='bg-white pt-4'>
          <img
            src='/images/top-sp-extend/menu-04/main-pic.webp'
            alt='main-picture'
            className='w-full aspect-[340/268] object-contain'
          />
        </div>

        <div className='bg-white pt-10 px-8 pb-[45px] flex flex-col relative'>
          <img
            src='/images/top/afternoon/pc-afternoon-bus.webp'
            alt='bus'
            className='w-[87px] object-contain absolute -bottom-[20px] -left-[10px]'
          />

          <img
            src='/images/top/afternoon/pc-afternoon-bus-stop.webp'
            alt='bus-stop'
            className='w-[111px] object-contain absolute -bottom-[27px] -right-4'
          />
        </div>
      </div>

      <img
        src='/images/top/morning/pc-morning-table.webp'
        alt='table'
        className='w-full aspect-[360/39] rounded-[4px] object-cover'
      />
    </div>
  )
}
